import React, { useContext } from "react";

import { UserContext } from "../../API";
import LogIn from "./LogIn";

import "./RequireUser.css";

export default function RequireUser({ children }) {
  const { token } = useContext(UserContext);

  return token ? (
    children
  ) : (
    <div className="page _auth">
      <LogIn />
    </div>
  );
}
